// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-container-cF7I3 {
  position: relative;
  --top-popup: 52px;
}

.select-label-KqJC_ {
  display: block;
  font-size: 14px;
  color: var(--color-neutral-800);
  margin-bottom: 8px;
}

.select-input-lrNxA {
  width: 100%;
  height: 44px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 15px;
  color: var(--color-neutral-500);
  border: 1px solid var(--color-neutral-300);
  border-radius: var(--radius-lg);
  padding: 0px 12px;
  cursor: pointer;
  user-select: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.select-input-lrNxA:focus { 
  border-color: var(--color-neutral-800);
  box-shadow: 0 0 0 0.5px var(--color-neutral-800);
}

.select-active-eFFo8 {
  color: black;
}

.select-disabled-LCJ06 {
  opacity: 0.5;
  pointer-events: none;
}

.select-icon-OjRP_ {
  --size: 22px;
  margin-right: 12px;
}

.select-value-E5BlB {
  flex: 1;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.select-expandMoreIcon-mZZjh {
  --size: 22px;
  flex-shrink: 0;
}

.select-disabled-LCJ06 .select-expandMoreIcon-mZZjh {
  cursor: default;
}

.select-clearIcon-tm440 {
  --size: 20px;
}

.select-popup-zbik6 {
  background-color: white;
  padding: 4px 0px;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/select/select.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,0CAA0C;EAC1C,+BAA+B;EAC/B,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,wDAAwD;AAC1D;;AAEA;EACE,sCAAsC;EACtC,gDAAgD;AAClD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB","sourcesContent":[".container {\n  position: relative;\n  --top-popup: 52px;\n}\n\n.label {\n  display: block;\n  font-size: 14px;\n  color: var(--color-neutral-800);\n  margin-bottom: 8px;\n}\n\n.input {\n  width: 100%;\n  height: 44px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 15px;\n  color: var(--color-neutral-500);\n  border: 1px solid var(--color-neutral-300);\n  border-radius: var(--radius-lg);\n  padding: 0px 12px;\n  cursor: pointer;\n  user-select: none;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.input:focus { \n  border-color: var(--color-neutral-800);\n  box-shadow: 0 0 0 0.5px var(--color-neutral-800);\n}\n\n.active {\n  color: black;\n}\n\n.disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.icon {\n  --size: 22px;\n  margin-right: 12px;\n}\n\n.value {\n  flex: 1;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.expandMoreIcon {\n  --size: 22px;\n  flex-shrink: 0;\n}\n\n.disabled .expandMoreIcon {\n  cursor: default;\n}\n\n.clearIcon {\n  --size: 20px;\n}\n\n.popup {\n  background-color: white;\n  padding: 4px 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `select-container-cF7I3`,
	"label": `select-label-KqJC_`,
	"input": `select-input-lrNxA`,
	"active": `select-active-eFFo8`,
	"disabled": `select-disabled-LCJ06`,
	"icon": `select-icon-OjRP_`,
	"value": `select-value-E5BlB`,
	"expandMoreIcon": `select-expandMoreIcon-mZZjh`,
	"clearIcon": `select-clearIcon-tm440`,
	"popup": `select-popup-zbik6`
};
export default ___CSS_LOADER_EXPORT___;
